// extracted by mini-css-extract-plugin
export var active = "_82-a";
export var activeIndicator = "_82-8";
export var animate = "_82-9";
export var disabled = "_82-b";
export var fullWidth = "_82-2";
export var lg = "_82-7";
export var md = "_82-6";
export var redoButtonTabGroup = "_82-0";
export var sm = "_82-5";
export var tabButton = "_82-3";
export var tabButtonsContainer = "_82-1";
export var xs = "_82-4";